var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgContact = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.055 13.148c-.795.453-.721 1.663.127 2.014l4.935 2.057v3.631a1.148 1.148 0 0 0 2.034.735l2.18-2.612 4.36 1.814a1.136 1.136 0 0 0 1.544-.868l2.252-14.625a1.121 1.121 0 0 0-.475-1.097 1.13 1.13 0 0 0-1.196-.05l-15.76 9zm1.833.896 12.014-6.859-7.726 8.628.043.035-4.331-1.804zm11.789 4.911-5.861-2.443L20.348 8.1l-1.671 10.856z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContact, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/contact.620a4e9a.svg";
export { ForwardRef as ReactComponent };